import { useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';

import Button from '@/components/Button';
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuTrigger
} from '@/components/DropdownMenu';
import MoreHorizontal from '@/icons/more-h.svg';

import { useOptions } from './hooks';
import { DialogItem } from './modals';

function DropdownMenuItem({ item }) {
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const { options, openOption, setOpenOption } = useOptions();
	const { t } = useTranslation();
	const focusRef = useRef(null);

	return (
		<>
			<DropdownMenu open={dropdownOpen} onOpenChange={setDropdownOpen}>
				<DropdownMenuTrigger asChild>
					<Button
						aria-label={t('myDocuments.folders.moreOptions', {
							folderName: item.name
						})}
						className="focus-visible:outline-none focus-visible:ring-transparent"
						size="small"
						type="button"
						variant="ghost"
					>
						<MoreHorizontal aria-hidden="true" className="rotate-180" />
					</Button>
				</DropdownMenuTrigger>
				<DropdownMenuContent
					className="py-2"
					side="right"
					onCloseAutoFocus={event => {
						if (focusRef.current) {
							focusRef.current.focus();
							focusRef.current = null;
							event.preventDefault();
						}
					}}
				>
					<DialogItem
						closeMenu={() => setDropdownOpen(false)}
						folderId={item.id}
						options={options}
						setOpenOption={setOpenOption}
					/>
				</DropdownMenuContent>
			</DropdownMenu>
			{options.map(({ Component, name }) => (
				<Component
					item={item}
					key={name}
					open={openOption === name}
					onOpenChange={setOpenOption}
				/>
			))}
		</>
	);
}

export default DropdownMenuItem;
